import React, { useState } from 'react';
import img1 from './../../../Assets/Image/image 30.png';
import img2 from './../../../Assets/Image/image 33.png';
import img3 from "./../../../Assets/Image/QRCODEHOMe.jpg";
import StaticCardComponent from "./StaticCardComponent.jsx";

import './ProvidedServices.css';

const ProvidedServices = () => {
  const cards = [
    {
      imgSrc: img3,
      title:
        "The best restaurant online menu and QR-code-table-ordering social media platform",
      text: "The social media network for restaurants and foodies that gets you discovered by thousands of local food lovers. Do away with paper menus, and showcase your items and menu changes in a flexible rich social-media-like AI-driven interactive interface. Customers can order themselves through QR codes, saving you on waiter costs",
    },
    {
      imgSrc: img1,
      title: "Best digital kitchen order management system for restaurants",
      text: "No more need for expensive paper printers at each food counter that need regular servicing for paper/ink. Our AI-driven digital kitchen manages order in a natural flow that maximises kitchen efficiencies",
    },
    {
      imgSrc: img2,
      title:
        "Delivery/Collection, subscriptions, offers, loyalty schemes, at just 0.2% and 24hrs settlement",
      text: "Handle all types of orders, Dine-in/Delivery/Collection, create food subscriptions for the first time in the world for new predictable revenue streams, and offers/loyalty schemes, for just 0.2% per transaction on our world's lowest cost contract-free EPOS. 24hrs settlement - no contract!",
    },
  ];

  return (
    <div className='FoodSelectionMainContainer'>
      {/* sevices  */}
      <div className='LandingSevices'>
        {
          cards?.map((card, idx) => (
            <StaticCardComponent key={idx} {...card} />
          ))
        }
        {/* <div className='col '>
          <div className='card border-0 '>
            <img src={img3} className="card-img-top" alt="..." />
            <div className='card-body'>
              <h5 className='card-title'>Best menu presentation and QR close table ordering social media network platform</h5>
              <p className={`card-text ${isExpanded ? "expanded" : ""}`}>The social media network for restaurants and foodies that gets you discovered by thousands of local food lovers through our social-media-like menu presentation format. Do away with paper menus, and showcase your items and menu changes in a flexible rich social-media-like AI-driven interactive interface. Customers can order themselves through QR codes, saving you on waiter costs</p>
              <button className="btn btn-link p-0" onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? "See Less" : "See More"}
              </button>
            </div>
          </div>
        </div>

        <div className='col'>
          <div className='card border-0'>
            <img src={img1} className="card-img-top" alt="..." />
            <div className='card-body'>
              <h5 className='card-title'>Best digital kitchen order management system</h5>
              <p className={`card-text ${isExpanded ? "expanded" : ""}`}>No more need for expensive paper printers at each food counter that need regular servicing for paper/ink. Our AI-driven digital kitchen manages order in a natural flow that maximises kitchen efficiencies</p>
              <button className="btn btn-link p-0" onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? "See Less" : "See More"}
              </button>
            </div>
          </div>
        </div>

        <div className='col'>
          <div className='card border-0'>
            <img src={img2} className="card-img-top" alt="..." />
            <div className='card-body'>
              <h5 className='card-title'>Delivery/Collection, subscriptions, offers, loyalty schemes, at just 0.2%</h5>
              <p className={`card-text ${isExpanded ? "expanded" : ""}`}>Handle all types of orders, Dine-in/Delivery/Collection, create food subscriptions for the first time in the world for new predictable revenue streams, and offers/loyalty schemes, for just 0.2% per transaction on our world's lowest cost EPOs</p>
              <button className="btn btn-link p-0" onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? "See Less" : "See More"}
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ProvidedServices;

